const About = () => {
  return (
    <div className="container border-md rounded rounded-5 bg-opacity-10 about-container p-2 shadow-md mt-5">
      <h1 className="fs-4 text-center mb-3">Who Am I?</h1>
      <p className="text-justify">
        Hi, I'm Sadric! I'm a passionate software engineer and aspiring data engineer with a bachelor's degree in Computer Science. 
        My expertise spans computer hardware, operating systems, and software development, with a strong focus on building scalable and efficient solutions. 
        I thrive on solving complex problems and leveraging technology to create innovative systems that drive real-world impact.
      </p>
      <p className="text-justify">
        My journey is fueled by a deep curiosity for data engineering and software architecture. I actively work on personal projects to enhance my skills, 
        exploring areas like API development, cloud computing, and data pipelines. You can find most of my work on{" "}
        <a href="https://github.com/sadric5" className="githubLink" target="_blank" rel="noopener noreferrer">
          GitHub
        </a>. I welcome feedback and collaboration! If you'd like to connect or discuss ideas, feel free to reach out{" "}
        <a href="/contact" target="_blank" rel="noopener noreferrer">here</a>.
      </p>

      <h2 className="fs-5 text-center">What I do?</h2>
      <ul className="shadow m-4">
        <li>Data Engineering (Apache airflow, kafka)</li>
        <li>Sofware development</li>
        <li>Web Scraping</li>
        <li>Connect to a database with python (mySQL)</li>
        <li>Build API with Django Restframework (Python)</li>
        <li>Create Websiste</li>
        <li>Lunch cloud server ( AWS /Linode)</li>
        <li>Write some script with Bash Or Python</li>
        <li>Windows machine troubleshooting</li>
        <li>and others related to sofware engeering</li>
      </ul>

      <h2 className="fs-5 text-center">Technical Skills</h2>
      <div className="row">
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Programming Languages</div>
          <ul>
            <li>Python</li>
            <li>JavaScript</li>
            <li>Html/CSS</li>
            <li>Swift/SwiftUI</li>
            <li>Java</li>
            <li>C</li>
            <li>SQL</li>
          </ul>
        </div>
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Framework</div>
          <ul>
            <li>Django</li>
            <li>React</li>
            <li>React Native (Mobile App)</li>
            <li>Bootstrap</li>
          </ul>
        </div>
      </div>

      <div className="row my-2">
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Cloud Provider</div>
          <ul>
            <li>AWS (Amazom Web Service)</li>
            <li>Azure (Microsoft)</li>
            <li>Linode</li>
          </ul>
        </div>
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Cloud Service</div>
          <ul>
            <li>VM (like AWS EC2)</li>
            <li>Azure Storage</li>
            <li>Aws RDS</li>
            <li>AWS Lambda</li>
            <li>AWS API Gateway</li>
            <li> and more ...</li>
          </ul>
        </div>
      </div>

      <div className="row my-2">
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Tools</div>
          <ul>
            <li>Git</li>
            <li>Vim</li>
            <li>Nano</li>
            <li>SSH (remote server adminstration)</li>
            <li>Numpy (python)</li>
            <li>Matplotlib (python)</li>
          </ul>
        </div>
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Software and hardware</div>
          <ul>
            <li>Mac OS X</li>
            <li>Windows</li>
            <li>Linux</li>
            <li>Raspberry PI</li>
          </ul>
        </div>
      </div>

      <div className="row my-2">
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Certificate</div>
          <ul>
            <li>Fundamentals of Red Hat Enterprise</li>
            <li>Introduction to Cloud Computing</li>
            <li>Introduction to Containers, Kubernetes, OpenShilft</li>
          </ul>
        </div>
        <div className="col-sm fs-5 shadow m-1">
          <div className="text-center fw-bold">Hobbies</div>
          <ul>
            <li>Love play Board Game (Chess is my favorite one)</li>
            <li>3D Modeling and Printing</li>
            <li>
              Reading (Courage To Be Disliked By Kishimi and Koga is one of my
              favorite book)
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;
